import { Component, OnInit, Input, ViewChild } from "@angular/core";
import {
  ModalController,
  NavParams,
  LoadingController,
  Events
} from "@ionic/angular";
import { HttpApiService } from "../../../services/http-api/http-api.service";
import { ConfigService } from "../../../services/config/config.service";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import * as moment from "moment";

@Component({
  selector: 'app-manage-purchase-inward',
  templateUrl: './manage-purchase-inward.page.html',
  styleUrls: ['./manage-purchase-inward.page.scss'],
})
export class ManagePurchaseInwardPage implements OnInit {
  @ViewChild("dataTable") public dataTable: any;

  public selected = [];
  public listOfUnConfirmPurchaseData = [];
  public count = 0;
  public selectedStoneList = [];
  public isSelect: Boolean = false;
  public columns = [];
  public flagModal: any;
  public voucherId: any;
  public voucherDetail = [];
  public page = 'managePurchaseInward'
  public voucherCount = 0;

  constructor(public navParams: NavParams,
    public modalCtrl: ModalController,
    private authService: AuthenticationService,
    public loadingController: LoadingController,
    public httpApiService: HttpApiService,
    public configService: ConfigService, ) { }

  async ngOnInit() {
    this.flagModal = await this.navParams.get("flagModal");
    this.columns = [
      { name: "Party", prop: "partyName" },
      { name: "Invoice No", prop: "invoiceNo" },
      { name: "Invoice Date", prop: "invDate" },
      { name: "Sequences In Invoice ", prop: "srNo" },
      { name: "Cts", prop: "totalCarat" },
    ]
    console.log(this.flagModal)
    if (this.flagModal == 'unconfirmPurchaseDetail') {
      this.findUnConfirmPurchaseData()
    } else {
      this.columns = [
        { name: "Party", prop: "stoneId" },
        { name: "Ie Invoice No", prop: "invoiceNo" },
        { name: "Invoice Date", prop: "invDate" },
        { name: "Sequence No", prop: "srNo" },
        { name: "Ct.", prop: "stoneCts" },
      ]
      let data = this.navParams.get("data");
      console.log(data);
      this.voucherId = data.id;
      this.findAllByVoucherId()
    }

  }

  showStoneId(stoneId) {
    if (!!stoneId && stoneId.indexOf("_") > -1) {
      return stoneId.slice(0, stoneId.indexOf("_"))
    } else {
      return stoneId
    }
  }

  closeModal() {
    this.modalCtrl.dismiss()
  }

  // unconfirm purchase data

  async findUnConfirmPurchaseData() {
    await this.configService.showLoader()
    let res: any;
    res = await this.httpApiService.findUnconfirmPurchaseData();
    let data = res.json();
    await this.loadingController.dismiss()
    if (res.status == 401) {
      this.authService.logout();
    } else if (res.status == 500) {
      await this.configService.showToast("error", data.error);
    } else if (res.status == 400) {
      await this.configService.showToast("error", data.error);
    } else {
      this.listOfUnConfirmPurchaseData = data.data;
      this.count = this.listOfUnConfirmPurchaseData.length;
    }
  }

  // purchase confirm selection

  onSelect(ev) {
    this.selected = ev.selected;
    this.selectedStoneList = [];
    this.selected.forEach(el => {
      this.selectedStoneList.push(el.id);
    })
    // console.log(this.isSelect, this.selectedStoneList, this.selectedStoneList.length, this.listOfPendingAssortment.length)
    if (this.selected.length == this.listOfUnConfirmPurchaseData.length) {
      this.isSelect = true;
    } else {
      this.isSelect = false;
    }
  }

  async selectAll(item) {
    if (item == true) {
      let arr = []
      this.selected = arr.concat(this.listOfUnConfirmPurchaseData)
      this.isSelect = true;
      this.selectedStoneList = [];
      this.selected.forEach(el => {
        this.selectedStoneList.push(el.id);
      });
    } else {
      this.isSelect = false;
      this.selected = []
      this.selectedStoneList = [];
    }
    console.log(this.selectedStoneList)
  }

  //confirm purchase Data 

  async confirmPurchaseData() {
    let res: any;
    let jsonObj = {
      listOfVoucherId: this.selectedStoneList
    }
    res = await this.httpApiService.confirmPurchaseData(jsonObj);
    let data = res.json();
    if (res.status == 401) {
      this.authService.logout();
    } else if (res.status == 500) {
      await this.configService.showToast("error", data.error);
    } else if (res.status == 400) {
      await this.configService.showToast("error", data.error);
    } else {
      this.selected = []
      this.isSelect = false;
      await this.configService.showToast("success", data.message);
      await this.findUnConfirmPurchaseData()
    }
  }

  //get data by Voucher Id
  async findAllByVoucherId() {
    await this.configService.showLoader();
    let res: any;
    res = await this.httpApiService.findPurchaseInStockByVoucherId(this.voucherId);
    let data = res.json();
    await this.loadingController.dismiss();
    if (res.status == 401) {
      this.authService.logout();
    } else if (res.status == 500) {
      await this.configService.showToast("error", data.error);
    } else if (res.status == 400) {
      await this.configService.showToast("error", data.error);
    } else {
      this.voucherDetail = data.data;
      this.voucherCount = data.data.length;
    }
  }


}
